import React, { useEffect, useState } from 'react';
import styles from '../../assets/scss/Billing/Billingtable.module.scss';
import Pagination from '../../Components/Common/Pagination';
import { FaEdit, FaEye, FaPrint } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGetReceivedBillsQuery } from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import InvoiceDesign from './InvoiceDesign';
import whatsApp from "../../../src/assets/images/LogoWhatsApp.png"
import { capitalize } from '../../utils/capitalize';

const ReceivedBills = ({ onStatsUpdate }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [status, setStatus] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const navigate = useNavigate();

  const offset = currentPage

  const { data, isLoading, isError, error } = useGetReceivedBillsQuery({
    fromDate: fromDate ? dayjs(fromDate).format('YYYY-MM-DD') : undefined,
    toDate: toDate ? dayjs(toDate).format('YYYY-MM-DD') : undefined,
    search,
    paymentMethod,
    status,
    offset,
    limit,
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [search, paymentMethod, fromDate, toDate, status]);

  useEffect(() => {
    if (data && onStatsUpdate) {
      onStatsUpdate({
        total: data.total || 0,
        totalReceivedAmount: data.totalReceivedAmount || 0,
        totalPendingAmount: data.totalPendingAmount || 0,
      });
    }
  }, [data, onStatsUpdate]);


  if (isError) {
    toast.error(error?.data?.message || 'Failed to load received bills');
  }

  const bills = data?.data || [];

  console.log(bills, "rtyrt");

  const totalPages = data?.total ? Math.ceil(data.total / limit) : 1;

  const clearFilters = () => {
    setSearch('');
    setPaymentMethod('');
    setStatus('');
    setFromDate(null);
    setToDate(null);
    setCurrentPage(1);
  };

  //print code start


  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("thermal");
  const [selectedBill, setSelectedBill] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);

  //print code end 

  return (
    <div>
      {/* --- Filters --- */}
      <div className={styles.filterBar}>
        <input
          type="text"
          placeholder="Search..."
          className={styles.searchInput}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          className={styles.inputs}
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
        >
          <option value="">Payment Method</option>
          <option value="cash">Cash</option>
          <option value="upi">UPI</option>
          <option value="credit">Credit</option>
        </select>
        <select
          className={styles.inputs}
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="">Select Status</option>
          <option value="paid">Paid</option>
          <option value="pending">Pending</option>
        </select>

        <DatePicker
          selected={fromDate}
          onChange={(date) => setFromDate(date)}
          dateFormat="dd.MM.yyyy"
          placeholderText="From Date"
          maxDate={new Date()}
          isClearable
          className={styles.inputss}
        />
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          dateFormat="dd.MM.yyyy"
          placeholderText="To Date"
          maxDate={new Date()}
          isClearable
          className={styles.inputss}
        />

        <button className={styles.clearBtn} onClick={clearFilters}>
          Clear All
        </button>
        <button
          className={styles.addBtn}
          onClick={() => navigate('/dashboard/AddBilling')}
        >
          + Sell Items
        </button>
      </div>

      {/* --- Table --- */}
      <div className={styles.tableWrapper}>
        {isLoading ? (
          <p>Loading bills...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Receipt ID</th>
                <th>Order ID</th>
                <th>Customer Name</th>
                <th>Phone Number</th>
                <th>Org Name</th>
                <th>Created Date</th>
                <th>Amount</th>
                <th>Payment Method</th>
                <th>Payment Status</th>
                <th>Billing Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {bills.length > 0 ? (
                bills.map((item) => (
                  <tr key={item._id}>
                    <td>{item?.receiptNo || '-'}</td>
                    <td className="notranslate">{item?.orderId?.orderId || '-'}</td>
                    <td>{item.customer?.firstName ? capitalize(item.customer.firstName) : '-'}</td>
                    <td>{item.customer?.phone || '-'}</td>
                    <td>{item.customer?.storeName ? capitalize(item.customer.storeName) : '-'}</td>
                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                    <td>₹ {item.totalAmount}</td>
                    <td>{item.paymentMethod ? capitalize(item.paymentMethod) : '-'}</td>
                    <td>
                      <span
                        className={`${styles.status} ${item.paymentStatus === 'paid' ? styles.paid : styles.unpaid
                          }`}
                      >
                        {item.paymentStatus}
                      </span>
                    </td>
                    {/* <td>{item.billingStatus}</td> */}
                    <td>
                      <span
                        className={`${styles.status} ${item.billingStatus === 'completed' ? styles.paid : styles.unpaid}`}
                      >
                        {item.billingStatus}
                      </span>
                    </td>

                    {/* <td>
                      <div className={styles.actions}>
                        <FaEdit
                          className={styles.icon}
                          onClick={() => navigate(`/dashboard/AddBilling?id=${item._id}&mode=edit`)}
                        />
                        <FaTrashAlt className={styles.icon} />
                        <FaEye
                          className={styles.icon}
                          onClick={() => navigate(`/dashboard/AddBilling?id=${item._id}&mode=view`)}
                        />
                      </div>
                    </td> */}
                    <td>
                      <div className={styles.actions}>
                        {/* {item.billingStatus !== 'completed' && (
                          <FaEdit
                            className={styles.icon}
                            onClick={() => navigate(`/dashboard/AddBilling?id=${item._id}&mode=edit`)}
                          />
                        )} */}
                        {item.billingStatus !== 'completed' && (
                          <button
                            className={styles.editButton}
                            onClick={() =>
                              navigate(`/dashboard/AddBilling?id=${item._id}&mode=edit`)
                            }
                          >
                            Calculate
                          </button>
                        )}

                        {/* <FaTrashAlt className={styles.icon} /> */}
                        <FaEye
                          className={styles.icon}
                          onClick={() => navigate(`/dashboard/AddBilling?id=${item._id}&mode=view`)}
                        />
                        {item.billingStatus === 'completed' && (
                          <FaPrint
                            className={styles.icon}
                            onClick={() => {
                              setSelectedBill(item); // store the bill
                              setShowPrintPopup(true);
                            }}
                          />
                        )}

                      </div>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan="7" className={styles.noData} style={{ textAlign: 'center' }}>
                    No bills found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
      <div className={styles.amountdiv}>
        <p >Total sales received amount: ₹ {data?.totalPaidAmount}</p>
        <p>Total sales pending amount: ₹ {data?.totalNotPaidAmount}</p>
      </div>

      {/* --- Pagination --- */}
      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
        <select
          className={styles.inputsbtn}
          value={limit}
          onChange={(e) => {
            setLimit(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={10}>10 rows</option>
          <option value={25}>25 rows</option>
          <option value={50}>50 rows</option>
        </select>
      </div>

      {showPrintPopup && selectedBill && (
        <PopupWrapper onClose={() => setShowPrintPopup(false)}>
          <div className={styles.popupHeader}>
            <div className={styles.header}>

              <h2 className={styles.tittle}>Share</h2>
              <span className={styles.closeIcon} onClick={() => setShowPrintPopup(false)}>
                ✕
              </span>
            </div>

            {/* Tab Buttons */}
            <div className={styles.tabHeader}>
              <button
                className={activeTab === "thermal" ? styles.activeTab : ""}
                onClick={() => setActiveTab("thermal")}
              >
                Thermal Print
              </button>
              <button
                className={activeTab === "whatsapp" ? styles.activeTab : ""}
                onClick={() => setActiveTab("whatsapp")}
              >
                WhatsApp Share
              </button>
            </div>


            {/* Tab Content */}
            <div className={styles.tabContent}>
              {activeTab === "thermal" && (
                <div className={styles.invoicePreview}>
                  <InvoiceDesign
                    mode="thermal"
                    data={selectedBill}
                  />
                </div>
              )}

              {activeTab === "whatsapp" && (
                <div className={styles.whatsappShare}>
                  <InvoiceDesign
                    mode="whatsapp"
                    data={selectedBill}
                  />
                </div>
              )}
            </div>

          </div>
        </PopupWrapper>
      )}


    </div>
  );
};

export default ReceivedBills;
